import { IDENTITY_CONFIG } from '../auth/utils/authConst'

export function setCookie(cName, value, exdays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + exdays)
  var cValue =
    escape(value) +
    (exdays === null
      ? ''
      : ';secure; SameSite=None; expires=' + exdate.toUTCString())
  document.cookie = cName + '=' + cValue
}

export function getCookie(cName) {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(';')
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='))
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1)
    x = x.replace(/^\s+|\s+$/g, '')
    if (x === cName) {
      return unescape(y)
    }
  }
}

export function deleteCookie(cName) {
  document.cookie = cName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export function setFreshCookie(cName, value, exdays) {
  if (getCookie(cName) !== null) {
    deleteCookie(cName)
  }
  setCookie(cName, value, exdays)
}

export function getToken() {
  // oidc-client keys the stored user by authority and client id, so this must be
  // derived from IDENTITY_CONFIG — a stale literal here reads no token and every
  // request goes out unauthenticated, with no error anywhere.
  const oidcStorage = JSON.parse(
    localStorage.getItem(
      `oidc.user:${IDENTITY_CONFIG.stsAuthority}:${IDENTITY_CONFIG.clientId}`
    )
  )
  return oidcStorage?.access_token ?? ''
}
